import React from 'react';
import MainPage from '../../../composents/MainPage';
import resources from '../../../services';
import DataTable from '../../../composents/DataTable';

const title = 'Users';
const headers = {
	icon: 'feather icon-user',
	title: title,
	description: 'track and manage all users information',
};

export default function AdminPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					{
						label: 'User name',
						field: 'fullName',
					},
					{
						label: 'User group',
						field: 'group',
						render: ['title'],
					},
					{
						label: 'User type',
						field: 'group',
						render: ['role'],
					},
				]}
				resource={resources.user}
				title={title}
				link="/administrators/users"
			/>
		</MainPage>
	);
}
